"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('link-one', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("g", {
    transform: "translate(21.646447, 22.353553) rotate(-45.000000) translate(-21.646447, -22.353553) translate(14.146447, -0.646447)"
  }, _react.default.createElement("path", {
    d: "M14.9769622,19.1908822 L14.9769622,7.26495624 C14.9769622,3.50123794 11.8429554,0.450141421 7.97696219,0.450141421 C4.11096894,0.450141421 0.97696219,3.50123794 0.97696219,7.26495624 L0.97696219,17.4871785"
  }), _react.default.createElement("path", {
    d: "M15,43.9237133 L15,33.7014911 C15,29.9377728 11.8659932,26.8866763 8,26.8866763 C4.13400675,26.8866763 1,29.9377728 1,33.7014911 L1,45.627417",
    transform: "translate(8.000000, 36.257047) scale(1, -1) translate(-8.000000, -36.257047) "
  }), _react.default.createElement("path", {
    d: "M7.97696219,26.005697 C11.8429554,26.005697 14.9769622,22.9546005 14.9769622,19.1908822"
  }), _react.default.createElement("path", {
    d: "M1,26.7014911 C4.86599325,26.7014911 8,23.6503946 8,19.8866763",
    transform: "translate(4.500000, 23.294084) scale(-1, -1) translate(-4.500000, -23.294084) "
  })))));
});

exports.default = _default;